import type { Attendee, PartyResource } from '@tyro/calendar/types';
import type { ReturnTypeDisplayName } from '@tyro/core/hooks';

export function getPartyName(
  partyInfo: Attendee['partyInfo'] | PartyResource['partyInfo'],
  getDisplayName: ReturnTypeDisplayName,
) {
  if (!partyInfo) return '';

  switch (partyInfo.__typename) {
    case 'GeneralGroup':
    case 'SubjectGroup':
    case 'YearGroupEnrollment':
    case 'ProgrammeStageEnrollment':
      return partyInfo.name;
    case 'Staff':
    case 'Student':
      return getDisplayName(partyInfo.person);
    default:
      return '';
  }
}

export function getPartyPerson(
  partyInfo: Attendee['partyInfo'] | PartyResource['partyInfo'],
) {
  if (!partyInfo) return null;

  switch (partyInfo.__typename) {
    case 'Staff':
    case 'Student':
      return partyInfo.person;
    default:
      return null;
  }
}

export function getPartyAvatarUrl(
  partyInfo: Attendee['partyInfo'] | PartyResource['partyInfo'],
) {
  if (!partyInfo) return '';

  switch (partyInfo.__typename) {
    case 'GeneralGroup':
    case 'SubjectGroup':
      return partyInfo.avatarUrl;
    case 'Staff':
    case 'Student':
      return partyInfo.person.avatarUrl;
    default:
      return '';
  }
}
